import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Carousel from '@ingka/carousel';
import { CSSEvent, CSSLiveBroadCast } from '../../types/model';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { setEvents, useAppContext } from '../../contextProviders/AppContext';
import * as selectors from '../../contextProviders/AppContext/selectors';
import LiveBroadcastEvent from '../../components/Event/LiveBroadcastEvent';
import { getAllLiveBroadcast } from '../../services/storeEventApi';
import ConditionalRender from '../../components/ConditionalRender';

const SubHeader = styled.h2`
  color: var(--colour-text-dark);
  margin-bottom: var(--space-75);

  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-bottom: var(--space-100);
  }`}
`;

const CarouselWrapper = styled.div`
  margin: var(--space-400) auto;
  .carousel__button {
    z-index: 3;
  }
  .item {
    width: 85%;
    ${({ theme }) => `${theme.breakpoints.md} {
      width: 31.8%;
    }`}
  }
`;

const LiveBroadcast = ({
  showStayInformedText = true,
  renderNoEvents = true,
}) => {
  const { t } = useTranslation();
  const { dispatch, useSelector } = useAppContext();
  const eventList = useSelector(selectors.getEvents);
  const [upcomingEvents, setUpcomingEvents] = useState<Array<CSSEvent>>([]);

  const fetchUpcomingNewEvents = async () => {
    try {
      return await getAllLiveBroadcast();
    } catch (e: any) {
      throw Error(e.code);
    }
  };

  const { data } = useQuery(['liveshows'], fetchUpcomingNewEvents, {
    enabled: true,
    staleTime: 20 * 60 * 1000, // 20 minutes caching
  });

  useEffect(() => { 
    if (data && data.length > 0) {
      const now = new Date();
      const liveShoppingData: CSSLiveBroadCast[] = data.filter((event: CSSLiveBroadCast) => new Date(event.label) >= now);
       if (liveShoppingData.length > 0) {
        setUpcomingEvents(data);
        // this is to reset the app context when returning from a carousel Event
        try {
          if (
            JSON.stringify(upcomingEvents[0]) !== JSON.stringify(eventList[0])
          ) {
            dispatch(setEvents(data));
          }
        } catch (e) {
          console.error(e);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  
  const carouselItems = upcomingEvents.map((event, i) => (
    <LiveBroadcastEvent
      event={{
        id: event.id,
        title: event.title,
        label: event.label,
        description: event.description,
        backgroundImage: event.backgroundImage,
        linkToLiveBroadCast: event.linkToLiveBroadCast
      }}
      key={i}
      slideShow={true}
    />
  ));

  return (
    <>
    <ConditionalRender
      predicate={upcomingEvents.length > 0}
      fallback={renderNoEvents ? null : undefined}
    >
        <SubHeader>{t('event.upcomingBroadcast')}</SubHeader>

        <CarouselWrapper>
          <Carousel
            id="events-carousel"
            children={carouselItems}
            isSlideShow={false}
            slideIndex={0}
            itemClass="item"
          />
        </CarouselWrapper>
        </ConditionalRender>
    </>
  );
};

export default LiveBroadcast;